import { __awaiter, __generator } from "tslib";
import httpAdapterFactory from '@wix/bookings-adapter-http-api';
var BookingsAPI = /** @class */ (function () {
    function BookingsAPI(instance, wixSdkAdapter, externalId) {
        this.wixSdkAdapter = wixSdkAdapter;
        var siteRevision = wixSdkAdapter.getSiteRevision();
        var csrfToken = wixSdkAdapter.getCsrfToken();
        this.httpAdapter = httpAdapterFactory(instance, siteRevision, csrfToken);
        this.wixSdkAdapter = wixSdkAdapter;
        this.externalId = externalId;
    }
    BookingsAPI.prototype.getTranslations = function (language) {
        return __awaiter(this, void 0, void 0, function () {
            var staticsBaseUrl;
            return __generator(this, function (_a) {
                staticsBaseUrl = this.wixSdkAdapter.getPlatformAppStaticsBaseUrl();
                return [2 /*return*/, this.httpAdapter.get(staticsBaseUrl + "assets/locale/messages_" + language + ".json", null)];
            });
        });
    };
    BookingsAPI.prototype.getStaffList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var serverBaseURl, queryFilter, pagingLimitParam;
            return __generator(this, function (_a) {
                serverBaseURl = this.wixSdkAdapter.getServerBaseUrl();
                queryFilter = encodeURIComponent("{\"resource.tags\":\"staff\"}");
                pagingLimitParam = '&query.paging.limit=500';
                if (this.wixSdkAdapter.isEditorMode()) {
                    return [2 /*return*/, this.httpAdapter.get(serverBaseURl + "_api/services-catalog-writer/resources?query.filter.stringValue=" + queryFilter + pagingLimitParam)];
                }
                return [2 /*return*/, this.httpAdapter.get(serverBaseURl + "_api/services-catalog/resources?query.filter.stringValue=" + queryFilter + pagingLimitParam)];
            });
        });
    };
    BookingsAPI.prototype.getSessionsForDate = function (_a) {
        var date = _a.date, timezone = _a.timezone, regionalSettings = _a.regionalSettings;
        return __awaiter(this, void 0, void 0, function () {
            var serverBaseUrl, externalIdQueryParam, baseQueryParams, serverEndpoint;
            return __generator(this, function (_b) {
                serverBaseUrl = this.wixSdkAdapter.getServerBaseUrl();
                externalIdQueryParam = this.externalId
                    ? "&externalId=" + this.externalId
                    : '';
                baseQueryParams = "?timezone=" + timezone + "&type=GROUP&regionalSettings=" + regionalSettings + externalIdQueryParam;
                serverEndpoint = "_api/bookings-viewer/daily-timetable/sessions/" + date.format('YYYY-MM-DD');
                return [2 /*return*/, this.httpAdapter.get("" + serverBaseUrl + serverEndpoint + baseQueryParams)];
            });
        });
    };
    BookingsAPI.prototype.getTimetableConfig = function (_a) {
        var timezone = _a.timezone, regionalSettings = _a.regionalSettings;
        return __awaiter(this, void 0, void 0, function () {
            var serverBaseUrl, serverEndpoint, externalIdQueryParam, baseQueryParams;
            return __generator(this, function (_b) {
                serverBaseUrl = this.wixSdkAdapter.getServerBaseUrl();
                serverEndpoint = "_api/bookings-viewer/daily-timetable/config";
                externalIdQueryParam = this.externalId
                    ? "&externalId=" + this.externalId
                    : '';
                baseQueryParams = "?timezone=" + timezone + "&type=GROUP&regionalSettings=" + regionalSettings + externalIdQueryParam;
                return [2 /*return*/, this.httpAdapter.get("" + serverBaseUrl + serverEndpoint + baseQueryParams)];
            });
        });
    };
    BookingsAPI.prototype.notifyOwnerNonPremium = function () {
        return __awaiter(this, void 0, void 0, function () {
            var serverBaseUrl;
            return __generator(this, function (_a) {
                serverBaseUrl = this.wixSdkAdapter.getServerBaseUrl();
                return [2 /*return*/, this.httpAdapter.post(serverBaseUrl + "_api/bookings-viewer/visitor/classes/nonPremium", '')];
            });
        });
    };
    return BookingsAPI;
}());
export { BookingsAPI };
//# sourceMappingURL=bookingsAPI.js.map